<button nz-button class="icon-btn" nzSize="small" (click)="copy()">
    <span nz-icon nzType="antd:v2-copy" class="text-base"></span>
</button>
